/**
 * @license
 * Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
 */

import '@polymer/iron-iconset-svg/iron-iconset-svg.js';
const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `<iron-iconset-svg name="cs-action-48" size="48" style="display: none;">
<svg>
  <defs>
    <g id="circle-exclamation">
      <path d="M24.03 0A24.155 24.155 0 1 1-.01 24.155 24.093 24.093 0 0 1 24.03 0zm0 4.66a19.5 19.5 0 1 1-19.4 19.5 19.45 19.45 0 0 1 19.4-19.5zm2.76 7.8h-5.05l.89 16.388h3.27zm-.17 24.754v-4.87h-4.71v4.87h4.71z"></path>
    </g>
  </defs>
</svg>
</iron-iconset-svg>`;

document.head.appendChild($_documentContainer.content);
